import { Controller } from "@hotwired/stimulus"

// Adds the `.in` class to any `.reveal` element when it enters the viewport.
// Triggers slightly before the element is fully on-screen so the transition
// runs while it's still drifting up — feels less jumpy.
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"))
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in")
          this.observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15, rootMargin: "0px 0px -12% 0px" })

    this.element.querySelectorAll(".reveal").forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
